module.exports = __webpack_public_path__ + "img/con2_hand.c0707338.png";